<template>
  <div>
    <div v-if="visible" class="gx-service-modal" aria-hidden="false" @click.self="toggleService">
      <div
        id="gx-service-dialog"
        class="gx-service-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="gx-service-dialog-title"
      >
        <div class="gx-service-modal__eyebrow" aria-hidden="true">
          <span></span>
          <b>✦ 观星树 · 客户服务中心 ✦</b>
          <span></span>
        </div>
        <h2 id="gx-service-dialog-title" class="gx-service-modal__title">扫码添加 <em>客服</em></h2>
        <p class="gx-service-modal__subtitle">早班 · 晚班 各设专属客服，扫码添加对应班次</p>

        <div class="gx-service-modal__cards">
          <article v-for="service in services" :key="service.name" class="gx-service-card">
            <div class="gx-service-card__qr-frame">
              <img
                :src="service.qrCodeUrl"
                :alt="service.name + '二维码'"
                class="gx-service-card__qr"
                :class="service.qrClass"
              >
            </div>
            <span class="gx-service-card__badge" :class="service.badgeClass">{{ service.name }}</span>
            <strong>{{ service.time }}</strong>
            <small>{{ service.timeDescription }}</small>
          </article>
        </div>

        <p class="gx-service-modal__notice">早 / 晚班客服 <b>每周轮换一次</b>，全天 9:00 - 23:00 不间断在线</p>
        <a
          class="gx-service-modal__guide"
          href="https://www.kdocs.cn/l/cma0rZ7Hb9pN"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>观星树使用流程</span>
          <b>www.kdocs.cn/l/cma0rZ7Hb9pN</b>
        </a>
      </div>
    </div>
    <button
      ref="trigger"
      type="button"
      class="gx-service-btn"
      title="客服咨询"
      aria-controls="gx-service-dialog"
      :aria-expanded="String(visible)"
      :style="btnLeft !== null ? { left: btnLeft + 'px', top: btnTop + 'px' } : {}"
      @pointerdown="handleDragStart"
      @click="handleBtnClick"
    >
      💬
    </button>
  </div>
</template>

<script>
export default {
  name: "FloatingQrCode",
  data() {
    return {
      visible: false,
      originalBodyOverflow: '',
      services: [
        {
          name: '早班客服',
          qrCodeUrl: 'https://xinghaohuo.oss-cn-beijing.aliyuncs.com/morning_service.jpg',
          time: '09:00-18:00',
          timeDescription: '上午 9 点 — 下午 6 点',
          badgeClass: 'is-morning',
          qrClass: 'is-morning'
        },
        {
          name: '晚班客服',
          qrCodeUrl: 'https://xinghaohuo.oss-cn-beijing.aliyuncs.com/night_service.jpg',
          time: '14:00-23:00',
          timeDescription: '下午 2 点 — 晚上 11 点',
          badgeClass: 'is-night',
          qrClass: 'is-night'
        }
      ],
      btnLeft: null,
      btnTop: null,
      isDragging: false,
      hasMoved: false,
      dragOffsetX: 0,
      dragOffsetY: 0,
      dragStartX: 0,
      dragStartY: 0
    };
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('pointermove', this.handleDragMove)
    window.removeEventListener('pointerup', this.handleDragEnd)
    this.setPageScrollLocked(false)
  },
  methods: {
    handleDragStart(e) {
      // 仅响应主键（鼠标左键 / 触摸 / 笔）
      if (e.button !== undefined && e.button !== 0) return
      this.isDragging = true
      this.hasMoved = false
      const rect = this.$refs.trigger.getBoundingClientRect()
      // 首次拖拽时，将 CSS 的 right/bottom 定位切换为 left/top，坐标取当前实际位置
      if (this.btnLeft === null) {
        this.btnLeft = rect.left
        this.btnTop = rect.top
      }
      this.dragOffsetX = e.clientX - rect.left
      this.dragOffsetY = e.clientY - rect.top
      this.dragStartX = e.clientX
      this.dragStartY = e.clientY
      try {
        this.$refs.trigger.setPointerCapture(e.pointerId)
      } catch (err) {
        // Pointer capture is not supported by all browsers.
      }
      window.addEventListener('pointermove', this.handleDragMove)
      window.addEventListener('pointerup', this.handleDragEnd)
      document.body.style.userSelect = 'none'
    },
    handleDragMove(e) {
      if (!this.isDragging) return
      const dx = e.clientX - this.dragStartX
      const dy = e.clientY - this.dragStartY
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
        this.hasMoved = true
      }
      const btn = this.$refs.trigger
      const maxLeft = window.innerWidth - btn.offsetWidth
      const maxTop = window.innerHeight - btn.offsetHeight
      let left = e.clientX - this.dragOffsetX
      let top = e.clientY - this.dragOffsetY
      left = Math.max(0, Math.min(left, maxLeft))
      top = Math.max(0, Math.min(top, maxTop))
      this.btnLeft = left
      this.btnTop = top
    },
    handleDragEnd() {
      if (!this.isDragging) return
      this.isDragging = false
      window.removeEventListener('pointermove', this.handleDragMove)
      window.removeEventListener('pointerup', this.handleDragEnd)
      document.body.style.userSelect = ''
    },
    handleBtnClick() {
      // 拖拽后不触发点击切换
      if (this.hasMoved) {
        this.hasMoved = false
        return
      }
      this.toggleService()
    },
    toggleService() {
      this.visible = !this.visible
      this.setPageScrollLocked(this.visible)
      if (!this.visible) {
        this.$nextTick(() => this.$refs.trigger.focus())
      }
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.visible) {
        this.toggleService()
      }
    },
    setPageScrollLocked(locked) {
      if (locked) {
        this.originalBodyOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return
      }

      document.body.style.overflow = this.originalBodyOverflow
    }
  }

};
</script>

<style scoped>
.gx-service-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: rgba(4, 12, 32, 0.68);
  backdrop-filter: blur(4px);
}

.gx-service-modal__panel {
  width: min(760px, 100%);
  max-height: 100%;
  overflow-y: auto;
  background: linear-gradient(135deg, #111833 0%, #060c20 100%);
  border: 1px solid rgba(212, 169, 70, 0.36);
  border-radius: 24px;
  box-shadow: 0 24px 72px rgba(0, 0, 0, 0.48);
  padding: 32px 36px;
  box-sizing: border-box;
  text-align: center;
  animation: gx-service-modal-enter 0.24s ease-out;
}

.gx-service-modal__eyebrow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #f2c900;
  font-size: 16px;
  letter-spacing: 4px;
}

.gx-service-modal__eyebrow span {
  width: 48px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e1bd14);
}

.gx-service-modal__eyebrow span:last-child {
  background: linear-gradient(90deg, #e1bd14, transparent);
}

.gx-service-modal__title {
  margin: 18px 0 8px;
  color: #ffffff;
  font-family: "STKaiti", "KaiTi", serif;
  font-size: clamp(32px, 4vw, 46px);
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: 4px;
}

.gx-service-modal__title em {
  color: #f2c900;
  font-style: normal;
}

.gx-service-modal__subtitle {
  margin: 0;
  color: #b9bdca;
  font-size: clamp(14px, 2vw, 18px);
  letter-spacing: 1px;
}

.gx-service-modal__cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin: 26px 0 20px;
}

.gx-service-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  padding: 20px 16px 18px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #c5a32e;
  border-radius: 20px;
}

.gx-service-card__qr-frame {
  width: min(180px, 100%);
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.gx-service-card__qr {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.gx-service-card__qr.is-night {
  transform: scale(1.18);
}

.gx-service-card__badge {
  margin-top: 14px;
  padding: 6px 24px;
  border-radius: 999px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
}

.gx-service-card__badge.is-morning {
  background: #b90000;
}

.gx-service-card__badge.is-night {
  background: #f2bf00;
  color: #171719;
}

.gx-service-card strong {
  margin-top: 14px;
  color: #1d2b59;
  font-size: clamp(22px, 3vw, 30px);
  line-height: 1;
}

.gx-service-card small {
  margin-top: 10px;
  color: #8d93a4;
  font-size: 15px;
}

.gx-service-modal__notice {
  margin: 0 0 20px;
  color: #c1c4ce;
  font-size: 15px;
  letter-spacing: 1px;
}

.gx-service-modal__notice b {
  color: #ffffff;
}

.gx-service-modal__guide {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-height: 64px;
  padding: 12px 24px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #f2c900, #e9b400);
  border-radius: 16px;
  color: #111111;
  font-size: clamp(16px, 2.2vw, 22px);
  font-weight: 700;
  line-height: 1.3;
  text-decoration: none;
}

.gx-service-modal__guide:hover,
.gx-service-modal__guide:focus {
  color: #111111;
  filter: brightness(1.06);
}

.gx-service-modal__guide:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 4px;
}

.gx-service-btn {
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 1001;
  width: 50px;
  height: 50px;
  border: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4A946, #F0C44A);
  color: #1d2745;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 4px 22px rgba(212, 169, 70, 0.65);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  user-select: none;
  touch-action: none;
}

.gx-service-btn:active {
  cursor: grabbing;
}

.gx-service-btn:hover,
.gx-service-btn:focus {
  transform: scale(1.12);
  box-shadow: 0 8px 36px rgba(212, 169, 70, 0.85);
  outline: none;
}

.gx-service-btn:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 3px;
}

@keyframes gx-service-modal-enter {
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 480px) {
  .gx-service-modal {
    padding: 16px;
  }

  .gx-service-modal__panel {
    padding: 20px 18px;
    border-radius: 20px;
  }

  .gx-service-modal__eyebrow {
    gap: 8px;
    font-size: 13px;
    letter-spacing: 2px;
  }

  .gx-service-modal__eyebrow span {
    width: 28px;
  }

  .gx-service-modal__title {
    margin-top: 18px;
    letter-spacing: 2px;
  }

  .gx-service-modal__subtitle {
    letter-spacing: 0;
  }

  .gx-service-modal__cards {
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 18px 0;
  }

  .gx-service-card {
    padding: 18px;
    border-radius: 20px;
  }

  .gx-service-card__qr-frame {
    width: min(180px, 100%);
  }

  .gx-service-card__badge {
    margin-top: 14px;
    padding: 6px 24px;
    font-size: 18px;
  }

  .gx-service-card strong {
    margin-top: 14px;
  }

  .gx-service-card small,
  .gx-service-modal__notice {
    font-size: 15px;
  }

  .gx-service-modal__notice {
    margin-bottom: 22px;
    line-height: 1.7;
  }

  .gx-service-modal__guide {
    flex-direction: column;
    gap: 4px;
    min-height: 0;
    padding: 16px;
    border-radius: 16px;
    font-size: 18px;
    overflow-wrap: anywhere;
  }

  .gx-service-btn {
    right: 16px;
    bottom: 16px;
    width: 46px;
    height: 46px;
  }
}
</style>
